import React from 'react';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import trash_icon from '../../../assets/images/icons/user-dashboard/trash-icon.png';
import CustomModalView from '../../../common/input/customModal/customModalView';
import { Navigate } from 'react-router-dom';
import ShiftModalView from '../ShiftModelView';
import CommonTableModalView from '../common-table/CommonTableModelView';


const CustomerDashboardView = (props) => {

    return (
        <>
            <div className="dashboard-body-area" style={{ width: '100%' }}>
                <section className="dashboard-page-title">
                    <div className="row justify-content-md-center">

                        <div className="col-md-4 findjob-search-bar">
                            <div className="cc-searchbar" style={{ width: "95%" }}>
                                <div className="srch-fld-row">
                                    <div className="srch-fld-col" style={{ width: '82%', borderRight: "0px" }}><input type="text" placeholder="Postcode" /></div>

                                    <div className="srch-fld-col srch-btn-col">
                                        <input type="submit" value="" className="form-submit-btn" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 ">
                            <div className="form-group">
                                <select id="inputcare" className="cc-searchbar form-control" style={{ height: '59px' }}>
                                    <option>Column View</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-md-3 ">
                            <div className="form-group">
                                <select id="inputcare" className="cc-searchbar form-control" style={{ height: '59px' }}>
                                    <option>Status</option>
                                </select>
                            </div>
                        </div>
                    </div>

                </section>
                <section className="dashboard-page-title">
                    <h2>Customer Job's Dashboard</h2>
                </section>
                <div className="table-area applied-job-table">
                    <Table responsive>
                        <thead>
                            <tr>
                                <th>id</th>
                                <th>Title</th>
                                <th>Shifts</th>
                                <th>Contract Type</th>
                                <th>Job Type</th>
                                <th>Patient Name</th>
                                <th>Postcode</th>
                                <th>Close Date</th>
                                <th>Posted By</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.jobs.map((job, index) => (
                                <tr>
                                    <td>{job.id}</td>
                                    <td><span className="title-crop">{job.title}</span></td>
                                    {job.shift_count > 0 ?
                                        <td className="shift-private" onClick={(e) => props.handleshift(job.id)} >{job.shift_count}</td>
                                        :
                                        <td className="shift-private" >0</td>
                                    }
                                    <td>{props.contract_type_arr[job.contract_type]}</td>
                                    <td>{job.job_type}</td>
                                    <td>{job.patient_name}</td>
                                    <td>{job.postcode}</td>
                                    <td>{job.close_date}</td>
                                    <td>{job.customer}</td>
                                    <td >
                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                            <div>
                                                <Link onClick={(e) => props.handleapplicant(job.id)} className="del_btn"><i style={{ marginRight: '0 8px', color: 'black', fontSize: '16px' }} class="fa fa-list fa-lg" aria-hidden="true"></i></Link></div>
                                                <div> <Link onClick={(e) => props.handlepreview(job.id)} className="del_btn"><i style={{ marginRight: '0 8px', color: 'black',marginLeft:'10px',fontSize:'16px' }} class="fa fa-eye fa-lg" aria-hidden="true"></i></Link></div>
                                                <div> <Link className="del_btn" onClick={(e) => props.handledelete(job.id)}><img style={{ margin: '0 8px',width:"16px" }} src={trash_icon} /></Link> </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </div>
            <ShiftModalView
                hideShiftModal={props.hideShiftModal}
                shift_modal_show={props.shift_modal_show}
                shift_detail={props.shift_detail}
            />
            <CommonTableModalView
                    modal_table_show={props.modal_table_show}
                    hideTableModal={props.hideTableModal}
                    application_detail={props.application_detail}
                />
        </>
    )

}

export default CustomerDashboardView;